/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthOnboardedRouteImport } from './routes/_auth/_onboarded'
import { Route as AuthAdminRouteImport } from './routes/_auth/admin'
import { Route as AuthOnboardingRouteImport } from './routes/_auth/onboarding'
import { Route as AuthOnboardedDashboardRouteImport } from './routes/_auth/_onboarded/dashboard'
import { Route as AuthCoordVerticalRouteImport } from './routes/_auth/coord.$vertical'
import { Route as AuthOnboardedApplyIndexRouteImport } from './routes/_auth/_onboarded/apply.index'
import { Route as AuthOnboardedApplyVerticalRouteImport } from './routes/_auth/_onboarded/apply.$vertical'
import { Route as AuthCoordVerticalIndexRouteImport } from './routes/_auth/coord.$vertical.index'
import { Route as AuthCoordVerticalRoundsRouteImport } from './routes/_auth/coord.$vertical.rounds'
import { Route as AuthCoordVerticalApplicantsIdRouteImport } from './routes/_auth/coord.$vertical.applicants.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOnboardedRoute = AuthOnboardedRouteImport.update({
  id: '/_onboarded',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardedDashboardRoute = AuthOnboardedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthOnboardedRoute,
} as any)
const AuthCoordVerticalRoute = AuthCoordVerticalRouteImport.update({
  id: '/coord/$vertical',
  path: '/coord/$vertical',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardedApplyIndexRoute = AuthOnboardedApplyIndexRouteImport.update({
  id: '/apply/',
  path: '/apply/',
  getParentRoute: () => AuthOnboardedRoute,
} as any)
const AuthOnboardedApplyVerticalRoute =
  AuthOnboardedApplyVerticalRouteImport.update({
    id: '/apply/$vertical',
    path: '/apply/$vertical',
    getParentRoute: () => AuthOnboardedRoute,
  } as any)
const AuthCoordVerticalIndexRoute = AuthCoordVerticalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthCoordVerticalRoute,
} as any)
const AuthCoordVerticalRoundsRoute = AuthCoordVerticalRoundsRouteImport.update({
  id: '/rounds',
  path: '/rounds',
  getParentRoute: () => AuthCoordVerticalRoute,
} as any)
const AuthCoordVerticalApplicantsIdRoute =
  AuthCoordVerticalApplicantsIdRouteImport.update({
    id: '/applicants/$id',
    path: '/applicants/$id',
    getParentRoute: () => AuthCoordVerticalRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/dashboard': typeof AuthOnboardedDashboardRoute
  '/coord/$vertical': typeof AuthCoordVerticalRouteWithChildren
  '/apply/$vertical': typeof AuthOnboardedApplyVerticalRoute
  '/coord/$vertical/rounds': typeof AuthCoordVerticalRoundsRoute
  '/apply/': typeof AuthOnboardedApplyIndexRoute
  '/coord/$vertical/': typeof AuthCoordVerticalIndexRoute
  '/coord/$vertical/applicants/$id': typeof AuthCoordVerticalApplicantsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/dashboard': typeof AuthOnboardedDashboardRoute
  '/apply/$vertical': typeof AuthOnboardedApplyVerticalRoute
  '/coord/$vertical/rounds': typeof AuthCoordVerticalRoundsRoute
  '/apply': typeof AuthOnboardedApplyIndexRoute
  '/coord/$vertical': typeof AuthCoordVerticalIndexRoute
  '/coord/$vertical/applicants/$id': typeof AuthCoordVerticalApplicantsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/_onboarded': typeof AuthOnboardedRouteWithChildren
  '/_auth/admin': typeof AuthAdminRoute
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/_auth/_onboarded/dashboard': typeof AuthOnboardedDashboardRoute
  '/_auth/coord/$vertical': typeof AuthCoordVerticalRouteWithChildren
  '/_auth/_onboarded/apply/$vertical': typeof AuthOnboardedApplyVerticalRoute
  '/_auth/coord/$vertical/rounds': typeof AuthCoordVerticalRoundsRoute
  '/_auth/_onboarded/apply/': typeof AuthOnboardedApplyIndexRoute
  '/_auth/coord/$vertical/': typeof AuthCoordVerticalIndexRoute
  '/_auth/coord/$vertical/applicants/$id': typeof AuthCoordVerticalApplicantsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/onboarding'
    | '/dashboard'
    | '/coord/$vertical'
    | '/apply/$vertical'
    | '/coord/$vertical/rounds'
    | '/apply/'
    | '/coord/$vertical/'
    | '/coord/$vertical/applicants/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin'
    | '/onboarding'
    | '/dashboard'
    | '/apply/$vertical'
    | '/coord/$vertical/rounds'
    | '/apply'
    | '/coord/$vertical'
    | '/coord/$vertical/applicants/$id'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/_onboarded'
    | '/_auth/admin'
    | '/_auth/onboarding'
    | '/_auth/_onboarded/dashboard'
    | '/_auth/coord/$vertical'
    | '/_auth/_onboarded/apply/$vertical'
    | '/_auth/coord/$vertical/rounds'
    | '/_auth/_onboarded/apply/'
    | '/_auth/coord/$vertical/'
    | '/_auth/coord/$vertical/applicants/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_onboarded': {
      id: '/_auth/_onboarded'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthOnboardedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_onboarded/dashboard': {
      id: '/_auth/_onboarded/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthOnboardedDashboardRouteImport
      parentRoute: typeof AuthOnboardedRoute
    }
    '/_auth/coord/$vertical': {
      id: '/_auth/coord/$vertical'
      path: '/coord/$vertical'
      fullPath: '/coord/$vertical'
      preLoaderRoute: typeof AuthCoordVerticalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_onboarded/apply/': {
      id: '/_auth/_onboarded/apply/'
      path: '/apply'
      fullPath: '/apply/'
      preLoaderRoute: typeof AuthOnboardedApplyIndexRouteImport
      parentRoute: typeof AuthOnboardedRoute
    }
    '/_auth/_onboarded/apply/$vertical': {
      id: '/_auth/_onboarded/apply/$vertical'
      path: '/apply/$vertical'
      fullPath: '/apply/$vertical'
      preLoaderRoute: typeof AuthOnboardedApplyVerticalRouteImport
      parentRoute: typeof AuthOnboardedRoute
    }
    '/_auth/coord/$vertical/': {
      id: '/_auth/coord/$vertical/'
      path: '/'
      fullPath: '/coord/$vertical/'
      preLoaderRoute: typeof AuthCoordVerticalIndexRouteImport
      parentRoute: typeof AuthCoordVerticalRoute
    }
    '/_auth/coord/$vertical/rounds': {
      id: '/_auth/coord/$vertical/rounds'
      path: '/rounds'
      fullPath: '/coord/$vertical/rounds'
      preLoaderRoute: typeof AuthCoordVerticalRoundsRouteImport
      parentRoute: typeof AuthCoordVerticalRoute
    }
    '/_auth/coord/$vertical/applicants/$id': {
      id: '/_auth/coord/$vertical/applicants/$id'
      path: '/applicants/$id'
      fullPath: '/coord/$vertical/applicants/$id'
      preLoaderRoute: typeof AuthCoordVerticalApplicantsIdRouteImport
      parentRoute: typeof AuthCoordVerticalRoute
    }
  }
}

interface AuthOnboardedRouteChildren {
  AuthOnboardedDashboardRoute: typeof AuthOnboardedDashboardRoute
  AuthOnboardedApplyVerticalRoute: typeof AuthOnboardedApplyVerticalRoute
  AuthOnboardedApplyIndexRoute: typeof AuthOnboardedApplyIndexRoute
}

const AuthOnboardedRouteChildren: AuthOnboardedRouteChildren = {
  AuthOnboardedDashboardRoute: AuthOnboardedDashboardRoute,
  AuthOnboardedApplyVerticalRoute: AuthOnboardedApplyVerticalRoute,
  AuthOnboardedApplyIndexRoute: AuthOnboardedApplyIndexRoute,
}

const AuthOnboardedRouteWithChildren = AuthOnboardedRoute._addFileChildren(
  AuthOnboardedRouteChildren,
)

interface AuthCoordVerticalRouteChildren {
  AuthCoordVerticalRoundsRoute: typeof AuthCoordVerticalRoundsRoute
  AuthCoordVerticalIndexRoute: typeof AuthCoordVerticalIndexRoute
  AuthCoordVerticalApplicantsIdRoute: typeof AuthCoordVerticalApplicantsIdRoute
}

const AuthCoordVerticalRouteChildren: AuthCoordVerticalRouteChildren = {
  AuthCoordVerticalRoundsRoute: AuthCoordVerticalRoundsRoute,
  AuthCoordVerticalIndexRoute: AuthCoordVerticalIndexRoute,
  AuthCoordVerticalApplicantsIdRoute: AuthCoordVerticalApplicantsIdRoute,
}

const AuthCoordVerticalRouteWithChildren =
  AuthCoordVerticalRoute._addFileChildren(AuthCoordVerticalRouteChildren)

interface AuthRouteChildren {
  AuthOnboardedRoute: typeof AuthOnboardedRouteWithChildren
  AuthAdminRoute: typeof AuthAdminRoute
  AuthOnboardingRoute: typeof AuthOnboardingRoute
  AuthCoordVerticalRoute: typeof AuthCoordVerticalRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthOnboardedRoute: AuthOnboardedRouteWithChildren,
  AuthAdminRoute: AuthAdminRoute,
  AuthOnboardingRoute: AuthOnboardingRoute,
  AuthCoordVerticalRoute: AuthCoordVerticalRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
